import React from "react";
import { NavLink} from 'react-router-dom';
import { withNamespaces } from 'react-i18next';

const PanelSidebar = ({menus, t}) => {
    let menu;

    if(menus) {
        menu = menus.map(menu => {
            let menuItems = menu.menuItems.map((item) => {
                const locationItem = {
                    pathname: item.href,
                    state: { fromDashboard: true }
                }
                return (
                    <NavLink to={locationItem} className="nav-item " key={item.id + '-menu-item'}>
                        <div className="nav-link light-color">
                            <i className={item.icon} /> &nbsp;
                            <p>{ t(item.name) }</p>
                        </div>

                    </NavLink>
                );
            });

            return (
                <React.Fragment key={menu.id + '-menu'}>
                    <li className="nav-header">{t(menu.name)}</li>
                    { menuItems }
                </React.Fragment>
            )
        })
    }

    return  menus ? (
        <nav className="mt-2">
            <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                { menu }
            </ul>
        </nav>
    ) : (
        <div className='center'> Loading... </div>
    );
};


export default withNamespaces()(PanelSidebar);
